import { useTranslation } from "react-i18next";
import ErrorPage from "./ErrorPage";

/**
 * Generic 404 — an unknown route, or a page whose item id doesn't exist any more.
 * Rendered in place; the URL the learner typed stays in the address bar.
 */
const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <ErrorPage
      code="404"
      title={t("errors.notFound.title")}
      message={t("errors.notFound.body")}
      actions={[
        {
          key: "home",
          label: t("errors.actions.backHome"),
          to: "/",
          variant: "primary",
        },
      ]}
    />
  );
};

export default NotFoundPage;
